import type {
  EquipmentAccessorial,
  EquipmentAccessorialType,
} from '@fv/models/equipment'

const countAccessorials = ['chains', 'load-bars', 'straps'] as const
type CountAccessorial = (typeof countAccessorials)[number]

function isCountAccessorial(
  key: EquipmentAccessorialType,
): key is CountAccessorial {
  return countAccessorials.some(accessorial => accessorial === key)
}

export function equipmentAccessorialFromKey(
  key: EquipmentAccessorialType,
): EquipmentAccessorial | undefined {
  if (key === 'tarps' || key === 'temp') {
    return undefined
  }

  if (isCountAccessorial(key)) {
    return { key, count: 1 }
  }

  return { key }
}

export function equipmentAccessorialsFromKeys(
  keys: EquipmentAccessorialType[],
): EquipmentAccessorial[] {
  return keys.flatMap(key => {
    const accessorial = equipmentAccessorialFromKey(key)
    return accessorial ? [accessorial] : []
  })
}
